import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export function FloatingAgentAvatar({ initials = 'OP', agentName = 'Operator', shiftUp = false }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const navigate = useNavigate();

  return (
    <div className={`fixed right-6 z-50 transition-all ${shiftUp ? 'bottom-24' : 'bottom-20'}`} data-testid="floating-agent">
      <button
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={() => navigate('/command')}
        className="relative flex h-[44px] w-[44px] items-center justify-center rounded-full text-[14px] font-bold text-white shadow-lg transition-transform hover:scale-105"
        style={{ background: 'linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)' }}
        data-testid="floating-agent-btn"
      >
        {initials}
      </button>
      {showTooltip && (
        <div
          className="absolute bottom-full right-0 mb-2 whitespace-nowrap rounded-lg px-3 py-2 text-[12px] font-medium text-white shadow-lg"
          style={{ backgroundColor: '#1B2B4B' }}
          data-testid="floating-agent-tooltip"
        >
          {agentName} — clicca per assistenza
          <div className="absolute -bottom-1 right-4 h-2 w-2 rotate-45" style={{ backgroundColor: '#1B2B4B' }} />
        </div>
      )}
    </div>
  );
}
